export default "__VITE_ASSET__BMLui26b__"